// RRレコメンド商品エリア、モーダル版
import { html } from 'lit-html';
import { Env } from '../../../env';
import { isSoloare } from '../../../models/js_env';
import { RrAreaProfile } from '../../../models/rr_profile';
import { CarouselItemsModal } from '../carousel_item/carousel_items_modal';
import { DoubleColumnCarouselItems } from '../carousel_item/double_column_carousel_items_modal';

export const RrAreaModal = (rrAreaProfile: RrAreaProfile, isLogin: boolean, isDoubleColumn = true) => {
  if (rrAreaProfile.rrAreaItems.length === 0)  return html``;

  if (isSoloare(Env.SITE_TYPE)) {
    // APIで行う大大・大カテコードのフィルタ処理によって表示する商品が存在しなくなったときに、
    // レコメンドエリアの枠が残ってしまうため、エレメントIDを埋め込んだdivのさらに上の階層のdivを予め非表示にし、
    // フィルタ処理後でも商品が存在する場合に、divのStyleを変更して表示させるようにする。
    if (document.getElementById(rrAreaProfile.placementName + '-parent')) document.getElementById(rrAreaProfile.placementName + '-parent')!!.style.display = 'block';
  }

  const mountTargetId = rrAreaProfile.mountTargetId ?? rrAreaProfile.placementName;
  document.getElementById(mountTargetId)?.removeAttribute("style");
  const carouselId =  mountTargetId + "-carousel";
  const carouselItemsModal = isDoubleColumn ? DoubleColumnCarouselItems(rrAreaProfile.rrAreaItems, isLogin, carouselId, rrAreaProfile.perView)
    : CarouselItemsModal(rrAreaProfile.rrAreaItems, isLogin, carouselId, rrAreaProfile.perView)
  return html`
  <div class="a-heading -typeh5 u-mb-24 u-mt-40">
    <h3 class="a-heading_text">こちらの商品はいかがですか</h3>
  </div>
  ${carouselItemsModal}
`;
}
